"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LocationsUtil = require("../../utils/LocationsUtil");

var _MarkerClusterer = require("./MarkerClusterer");

var _MarkerClusterer2 = _interopRequireDefault(_MarkerClusterer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherStoreMap = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherStoreMap, _Component);

  function VoucherStoreMap() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherStoreMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherStoreMap.__proto__ || (0, _getPrototypeOf2.default)(VoucherStoreMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      map: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherStoreMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var map = new google.maps.Map(this.mapNode, {
        center: (0, _LocationsUtil.getCoordinates)("Helsinki"),
        zoom: 12,
        maxZoom: 14,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: true
      });
      this.setState({ map: map }, function () {
        _this2.createMarkers();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement("div", { ref: function ref(node) {
          return _this3.mapNode = node;
        }, className: "map" });
    }
  }, {
    key: "createMarkers",
    value: function createMarkers() {
      var _this4 = this;

      var markers = this.getMarkers();
      var options = this.getClustererOptions();
      var markerClusterer = new _MarkerClusterer2.default(this.state.map, markers, options);

      google.maps.event.addListener(markerClusterer, "clusterclick", function (cluster) {
        var infoWindow = _this4.createClusterInfoWindow(cluster);
        infoWindow.open(_this4.state.map);
        _this4.redrawClusters();
      });

      this.setState({ markerClusterer: markerClusterer }, function () {
        if (markers.length) {
          _this4.fitBounds();
        }
      });
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      var _this5 = this;

      var markers = [];
      this.props.places.forEach(function (place) {
        if ((0, _LocationsUtil.legitCoordinates)(place.latitude, place.longitude)) {
          var marker = _this5.createMarker({
            lat: place.latitude,
            lng: place.longitude
          });
          marker.name = place.name;
          var infoWindow = _this5.createInfoWindow(place);
          marker.addListener("click", function () {
            infoWindow.open(_this5.state.map, marker);
          });
          markers.push(marker);
        }
      });
      return markers;
    }
  }, {
    key: "createMarker",
    value: function createMarker(position) {
      return new google.maps.Marker({
        map: this.state.map,
        draggable: false,
        position: position,
        icon: "/img/maaporssi-map-marker.png"
      });
    }
  }, {
    key: "createClusterInfoWindow",
    value: function createClusterInfoWindow(cluster) {
      var markers = cluster.getMarkers();
      var markersText = markers.map(function (marker) {
        return marker.name.trim();
      }).join("<br />");
      var content = "\n      <p class=\"marker-window\">\n        " + markersText + "\n      </p>\n    ";
      var position = cluster.getCenter();
      var pixelOffset = new google.maps.Size(-2, -38);
      return new google.maps.InfoWindow({ content: content, position: position, pixelOffset: pixelOffset });
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(place) {
      var content = "\n      <p class=\"marker-window\">\n        <b><span>" + place.name + "</span></b>\n      </p>\n    ";
      return new google.maps.InfoWindow({ content: content });
    }
  }, {
    key: "fitBounds",
    value: function fitBounds() {
      var markers = this.state.markerClusterer.getMarkers();
      var bounds = new google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        bounds.extend(marker.getPosition());
      });
      this.state.map.fitBounds(bounds);
    }
  }, {
    key: "getClustererOptions",
    value: function getClustererOptions() {
      var styles = [{
        url: "/img/maaporssi-map-marker.png",
        height: 46,
        width: 33,
        textColor: "#f7f7f7",
        textSize: 16,
        anchor: [6, 0],
        iconAnchor: [17.5, 40]
      }];

      return {
        maxZoom: 20,
        zoomOnClick: true,
        gridSize: 50,
        styles: styles
      };
    }

    /**
     * There is a bug in MarkerClusterer, see:
     * https://github.com/Geolim4/google-maps-utility-library-v3/issues/210
     * https://code.google.com/p/google-maps-utility-library-v3/issues/detail?id=252
     *
     * This repositions the map so markers get redrawn.
     */

  }, {
    key: "redrawClusters",
    value: function redrawClusters() {
      var mapCenter = this.state.map.getCenter();
      var coordinates = new google.maps.LatLng(mapCenter.lat() + 0.0000001, mapCenter.lng());
      this.state.map.setCenter(coordinates);
    }
  }]);
  return VoucherStoreMap;
}(_react.Component), _class.propTypes = {
  places: _react.PropTypes.array
}, _temp2);
exports.default = VoucherStoreMap;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/map/VoucherStoreMap.js
 ** module id = 1158
 ** module chunks = 0
 **/